import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Form, Input, Checkbox, Steps } from "antd";

const FormItem = Form.Item;
const Step = Steps.Step;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},

	mapPropsToFields(props) {
		return props.fields;
	}
})
class ConfirmationForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	render() {
		let wizardNamePart = "";
		let routerStore = this.props.routerStore;

		if ((routerStore.routerState.routeName != "newcampaign" && routerStore.routerState.routeName != "duplicatecampaign") || this.props.form.getFieldValue("saveWizard") == true) {
			wizardNamePart = (
				<FormItem style={{ marginBottom: 10 }} label="Wizard Name">
					{this.props.form.getFieldDecorator("name", {
						rules: [
							{
								required: true,
								message: "Wizard name is required"
							}
						]
					})(<Input type="text" />)}
				</FormItem>
			);
		}
		let saveWizardPart = "";
		if (routerStore.routerState.routeName == "newcampaign" || routerStore.routerState.routeName == "duplicatecampaign") {
			saveWizardPart = (
				<FormItem style={{ marginBottom: 10 }}>
					{this.props.form.getFieldDecorator("saveWizard", {
						valuePropName: "Checked"
					})(<Checkbox>Also create wizard</Checkbox>)}
				</FormItem>
			);
		}
		return (
			<Form>
				<FormItem label="Campaign Name" style={{ marginBottom: 10 }}>
					{this.props.form.getFieldDecorator("campaignName", {
						rules: [
							{
								required: true,
								message: "Campaign name is required"
							}
						]
					})(<Input type="text" />)}
				</FormItem>
				{saveWizardPart}
				{wizardNamePart}
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class ConfirmationTab extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};
	onFieldsChange = changedFields => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;
		const result = {
			name: Form.createFormField(stateForm.name),
			saveWizard: Form.createFormField(stateForm.saveWizard),
			campaignName: Form.createFormField(stateForm.campaignName)
		};
		return result;
	};

	render() {
		const {
			rootStore: { routerStore }
		} = this.props;

		return (
			<ConfirmationForm
				fields={this.mapPropsToFields()}
				routerStore={routerStore}
				onFieldsChange={this.onFieldsChange}
				wrappedComponentRef={internalForm => {
					if (internalForm != null) {
						this.internalForm = internalForm;
					}
				}}
			/>
		);
	}
}

export default ConfirmationTab;
